import { render } from "./CopyDetailsPannel.vue?vue&type=template&id=9faed474"
import script from "./CopyDetailsPannel.vue?vue&type=script&lang=js"
export * from "./CopyDetailsPannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__